// Fire-and-forget tracker kliknięć na elementy (wydarzenia, atrakcje, wystawcy, ...).
// Bez PII, bez klucza. Wysyłamy przez sendBeacon (nie blokuje UI, przetrwa nawigację).
// Nie liczymy tego samego elementu 2× w bardzo krótkim odstępie (debounce w ramach sesji).

const RECENT_KEY = "lyp-click-recent";
const RECENT_TTL_MS = 5000; // ten sam item nie liczy się 2× w ciągu 5 s

function _shouldSkip(category, itemId) {
  try {
    const raw = window.sessionStorage.getItem(RECENT_KEY);
    const map = raw ? JSON.parse(raw) : {};
    const key = `${category}:${itemId}`;
    const now = Date.now();
    if (map[key] && now - map[key] < RECENT_TTL_MS) return true;
    map[key] = now;
    // czyść wpisy starsze niż 60 s
    for (const k of Object.keys(map)) {
      if (now - map[k] > 60000) delete map[k];
    }
    window.sessionStorage.setItem(RECENT_KEY, JSON.stringify(map));
    return false;
  } catch {
    return false; // brak sessionStorage → i tak liczymy
  }
}

/**
 * Zarejestruj kliknięcie w konkretny element aplikacji.
 * @param {string} category  event | exhibitor | zone | attraction | game | wargame | bigformat | news | prototype | pin
 * @param {string} itemId    id elementu (musi być stabilne w czasie)
 * @param {string} [label]   opcjonalna etykieta czytelna dla człowieka (np. tytuł wydarzenia)
 */
export function trackClick(category, itemId, label = "") {
  try {
    if (typeof window === "undefined") return;
    if (window.location.pathname.startsWith("/mgmt-lyp-")) return; // admin nie liczy
    if (!category || !itemId) return;
    if (_shouldSkip(category, itemId)) return;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track-click`;
    const body = new Blob(
      [JSON.stringify({ category, itemId: String(itemId), label: String(label || "") })],
      { type: "application/json" }
    );
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, body);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category, itemId, label }),
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* silent */
  }
}
